import { render, staticRenderFns } from "./JSelectDepartModal.vue?vue&type=template&id=b136063a&scoped=true"
import script from "./JSelectDepartModal.vue?vue&type=script&lang=js"
export * from "./JSelectDepartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b136063a",
  null
  
)

export default component.exports